import { render } from "./ManageMetadata.vue?vue&type=template&id=36697dd4&ts=true"
import script from "./ManageMetadata.vue?vue&type=script&lang=ts"
export * from "./ManageMetadata.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__